import { Input, Space, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import Icon from 'components/icons';
import styled from 'styled-components';
import { colors } from 'constants/styles/colors';
const { Text } = Typography;
import { TooltipPlacement } from 'antd/es/tooltip';
import { screenMd } from 'constants/styles/breakpoints';

const StyledInput = styled(Input)`
  height: 36px;
  padding: 8px 10px;
  border-radius: 10px;

  &:focus {
    border: 1px solid ${colors.palette.Business_DataVizLilacLighter};
    background: ${colors.palette.Business_LightThemeGreyLighter};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    padding-right: 45px;

    ${screenMd} {
      padding-right: 10px;
    }
  }
`;

const Label = styled(Text)<{ $editIconOutside?: boolean }>`
  cursor: pointer;
  padding: 8px 10px;

  ${({ $editIconOutside }) => !$editIconOutside && 'padding-left: 40px;'}
`;

const EditIcon = styled(Icon)<{ $editIconOutside?: boolean }>`
  position: absolute;
  left: ${({ $editIconOutside }) => ($editIconOutside ? '-45px' : '7px')};
  top: 50%;
  transform: translateY(-50%);
`;

const StyledInputWrapper = styled.div`
  position: relative;
  width: 100%;

  .check-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    color: ${colors.palette.Business_DataVizLilacLighter};
    font-size: 16px;
    background: ${colors.palette.Business_LightThemeGreyLighter};
    border-radius: 50%;
    padding: 4px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);

    ${screenMd} {
      display: none !important;
    }
  }
`;
const InputText: React.FC<{
  value: string;
  disabled?: boolean;
  disabledTooltipText?: string;
  tooltipPlacement?: TooltipPlacement;
  editIconOutside?: boolean;
  onSave: (newValue: string) => void;
}> = ({ value, disabled, onSave, disabledTooltipText, tooltipPlacement, editIconOutside }) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleSave = (e?: React.MouseEvent | React.KeyboardEvent) => {
    e?.preventDefault();
    e?.stopPropagation();

    try {
      if (!inputValue || inputValue === value) return;
      onSave(inputValue);
    } finally {
      setEditing(false);
    }
  };

  const handleCancel = () => {
    setEditing(false);
    setInputValue(value);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (disabled) return;
    if (!editing) setEditing(true);
  };

  return (
    <StyledInputWrapper>
      <Tooltip arrowPointAtCenter title={disabledTooltipText} placement={tooltipPlacement}>
        <EditIcon
          size="small"
          icon="Edit2"
          style={{ opacity: disabled ? 0.3 : 1 }}
          onClick={handleEdit}
          $editIconOutside={editIconOutside}
        />
      </Tooltip>
      {editing ? (
        <>
          <StyledInput
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={handleCancel}
            onPressEnter={handleSave}
            onKeyDown={(e) => {
              if (e.key === 'Escape') handleCancel();
            }}
            autoFocus
          />
          <Icon className="check-icon" icon="Check2" onMouseDown={handleSave} />
        </>
      ) : (
        <Label
          ellipsis={{ tooltip: inputValue }}
          onClick={handleEdit}
          $editIconOutside={editIconOutside}
        >
          {inputValue}
        </Label>
      )}
    </StyledInputWrapper>
  );
};

export default InputText;
